export const getBirthYear = (age) =>
  new Date(new Date().getFullYear() - (age || 0), 0, 1);

export const checkTooOld = (date) =>
  new Date() - (new Date().getTime() - date.getTime()) <
  new Date(getBirthYear(18)).getTime();

export const checkTooYoung = (date) =>
  new Date() - (new Date().getTime() - date.getTime()) >
  new Date(getBirthYear(2)).getTime();

export const addMiliSeconds = (date, ms) => new Date(date.getTime() + ms);
